import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Aviation, Order } from "../../../services";
import "react-loading-skeleton/dist/skeleton.css";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import { toast } from "react-toastify";
import { requestErrorDisplay } from "../../../utils";
import { useTranslation } from "react-i18next";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomButton from "../../custom/custom-button/CustomButton";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import style from "./confirmModal.module.scss";
import CustomTextarea from "../../custom/custom-textarea/CustomTextarea";
import { useSelector } from "react-redux";

const CancelApp = ({ item, orderIds, onClose, onUpdateData, isAirOrder = false }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);

  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const resolvedOrderIds = Array.isArray(orderIds)
    ? orderIds
    : item?.id !== undefined && item?.id !== null
      ? [item.id]
      : [];
  const isMultipleOrders = resolvedOrderIds.length > 1;

  const createOrder = () => {
    if (!comment.trim()) {
      const message = t("cancelOrder.cancelReasonRequired");
      setError(message);
      toast.error(message);
      return;
    }
    setError("");

    const data = {
      orderIds: resolvedOrderIds,
      comment: comment.trim(),
      ...(isAirOrder ? {} : { moderator: user?.name || "" }),
    };

    const Service = isAirOrder ? Aviation : Order;

    setIsLoading(true);
    Service.canceled(data)
      .then(() => {
        setError("");
        onClose();
        onUpdateData();
        toast.info(t("cancelOrder.orderSuccessfullyCancelled"));
      })
      .catch((error) => {
        requestErrorDisplay(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return ReactDOM.createPortal(
    <div className={style.modalOverlay} data-portal-modal="true">
      <div className={style.modalContainer}>
        <div className={style.topbar}>
          <h2 className={style.modalTitle}>
            {t(isMultipleOrders ? "cancelOrder.cancelOrdersTitle" : "cancelOrder.cancelTitle")}
          </h2>
          <button
            type="button"
            className={style.closeBtn}
            onClick={onClose}
            aria-label={t("cancelOrder.close")}
          >
            <CloseIconNew />
          </button>
        </div>

        <div className={style.card}>
          <CustomTextarea
            labelText={t("cancelOrder.cancelReasonLabel")}
            placeholder={t("cancelOrder.cancelReasonRequired")}
            isBgGray
            rows={2}
            errorText={!comment.trim() && error}
            inputType="text"
            value={comment}
            onChangeValue={(value) => {
              setComment(value);
              if (value) setError("");
            }}
          />
        </div>

        <div className={style.modalActions}>
          <CustomButton
            isCancel
            text={t("cancelOrder.cancelButton")}
            onClick={onClose}
            disabled={isLoading}
          />
          <CustomButton
            isNavy
            text={t("cancelOrder.submitButton")}
            onClick={createOrder}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CancelApp;
